import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SideJoke } from '../components/shelves/SideJoke';
import { asyncReceiveGeeksJoke } from '../store/plain/geeksJoke/action';

export default function Sidebar() {
  const dispatch = useDispatch();
  const { geeksJoke = [] } = useSelector((state) => state);

  useEffect(() => {
    if (!geeksJoke) dispatch(asyncReceiveGeeksJoke());
  }, [dispatch, geeksJoke]);

  return (
    <div className="pr-4 lg:sticky lg:top-20 lg:w-48 xl:w-56">
      {geeksJoke && <SideJoke geeksJoke={geeksJoke} />}
    </div>
  );
}
